import { matchPath } from 'react-router-dom';
import type { RedirectProps, RouteProps } from '../routes';
import { anyRoutes } from '../routes';

export function makeMatchRoute(requestPath: string) {
  return function matchRoute(route: RouteProps) {
    return matchPath(requestPath, route);
  };
}

function appendRedirectParam(originalUrl: string, redirectTo: string): string {
  if (redirectTo === '/login' || redirectTo === '/login/expert') {
    const params = new URLSearchParams({ redirect_uri: originalUrl });
    return `${redirectTo}?${params.toString()}`;
  }
  return redirectTo;
}

export default function redirect(
  path: string,
  antiRoutes: Array<RouteProps>,
  redirects: Array<RedirectProps>,
  fallback: string
): RedirectProps | null {
  const routeMatcher = makeMatchRoute(path);

  const redirect = redirects.find((route) => path === route.from!);

  if (!redirect && !anyRoutes.some(routeMatcher) && antiRoutes.some(routeMatcher)) {
    const to = appendRedirectParam(path, fallback);

    return { to, from: path };
  }

  return null;
}
